/**
 * The conversion types one `domain.customEventConversions` entry maps its action to.
 *
 * Entries exist in two stored shapes: the legacy `{ event: 'X', value? }` and the
 * `{ events: ['X', ...], value? }` the API migrates to (magellan-api #2694). Every
 * read has to accept both, so derive the list here rather than reaching for either key.
 *
 * @param {{event?: string, events?: string[]}} [cfg] - one customEventConversions entry
 * @returns {string[]} the types it carries, empty when it carries none
 */
export const conversionTypesOf = (cfg) => (Array.isArray(cfg?.events) ? cfg.events : cfg?.event ? [cfg.event] : []);

/**
 * The actions a `domain.customEventConversions` map classifies as a given conversion type.
 *
 * Replaces the retired `domain.purchaseEvents` / `cartAddEvents` / `cartCreateEvents`
 * columns: the map is now the only source of truth for that classification.
 *
 * @param {Object} [customEventConversions] - the domain's customEventConversions map
 * @param {string} type - a conversion type, e.g. 'Purchase'
 * @returns {string[]} the actions carrying that type, in map order
 */
export const actionsForConversionType = (customEventConversions, type) =>
  Object.entries(customEventConversions || {})
    .filter(([, cfg]) => conversionTypesOf(cfg).includes(type))
    .map(([action]) => action);
